export default "__VITE_ASSET__jfjdrChi__"